<div class="ui-g-12">

  <div class="ui-g">
    <div class="ui-g-6 ui-md-6" *ngIf="data != null">
      <div class="ui-g-12 ui-md-12 ui-sm-12 store-overview-block">
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.descrizione'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.descrizione }}
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.superficie'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.superficie }}
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.area'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.area }}
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.insegna'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.insegna }}
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.canale'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.canale }}
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.data_apertura'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.data_apertura }}
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.data_chiusura'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.data_chiusura }} &nbsp;
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.parita'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          {{ storeInfo.parita }} &nbsp;
        </div>
        <div class="ui-g-4 ui-md-4 ui-sm-12">
          {{ storeInfoDesc['stores.note'] }}
        </div>
        <div class="ui-g-8 ui-md-8 ui-sm-12">
          -----
        </div>
      </div>
      <div class="ui-g-12 ui-md-12 ui-sm-12 store-overview-block">
        <p>
          &nbsp;
        </p>
      </div>
    </div>
    <div class="ui-g-6 ui-md-6">
      <div *ngFor="let indicator of indicators" class="ui-g-6 ui-md-6 ui-sm-12">
        <app-infobox [pointData]="indicator.pointData" [t]="indicator.t" [options]="indicator.options"></app-infobox>
      </div>
    </div>
  </div>

  <p-dialog header="{{ 'common.error' | translate }}" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ selectOneError }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-single-store/analysis-single-store-overview.component.html